<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="`maintenance-${_uid}`", :value="open")
      template(v-if="!open" )
        button.button.success(slot="trigger", v-if="request") Detail
        a.fa-stack.fa-lg(slot="trigger", v-else)
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Intervention request IR{{request.id}}
      .row
        .column
          vehicle(type="compact-card", :item="request.vehicle")
        .column
          label Description
          div {{request.description}}
          label Created at
          div  {{$dateFormat(request.created_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          label Expiry
          div  {{$dateFormat(request.expiry, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          //CreateSubInterventionRequestReveal(:request="body",  v-if="request.linked_intervention_request_id === null")
      MaintenanceRequestList(:request="request", :filters="filters", listing-type="detail-listing", v-if="request.linked_requests.length")
</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";
import InterventionRequestForm from "../../components/structure/forms/InterventionRequestForm.vue";
import {EventBus} from "../../eventBus";
import MaintenanceRequestList from "./MaintenanceRequestList.vue";
import Vehicle from 'components/backoffice/Vehicle'
import CreateInterventionRequestReveal from "./CreateInterventionRequestReveal.vue";
import {mapState} from "vuex";
import CreateSubInterventionRequestReveal from "./CreateSubInterventionRequestReveal.vue";

export default {
  name: 'DetailInterventionRequestReveal',
  components: {
    CreateSubInterventionRequestReveal,
    InterventionRequestReveal: CreateInterventionRequestReveal,
    Vehicle,
    MaintenanceRequestList,
    InterventionRequestForm,
    SelectizeVehicle,
    ActionButton,
    ModalReveal,
    DatePicker
  },
  data() {
    return {
      filters: {
        parent_intervention_request_id: this.request.id,
        vehicle_id: null,
      },
      body: {
        status: null,
        linked_intervention_request_id: this.request.id,
        maintenance_driver_id: null,
        vehicle_id: this.request.vehicle.id,
        priority: null,
        type: null,
        description: null,
        expiry: null,
        has_linked_requests: true,
      }
    }
  },
  created() {

  },
  methods: {
    save() {
      return KeplerBackofficeSdk.maintenanceRequest.select(this.request).update(this.request, () => {
        MaggieHelper.notification('', 'maintenance request updated')
        EventBus.$emit('reload-list')
        EventBus.$emit('close-modal')
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),

  },
  props: {
    request: null,
    open: false
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DetailInterventionRequestReveal.vue?3bdc30be